import React from 'react';
import { ClickAwayListener, MenuList, MenuItem, Paper, styled, Stack, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { componentColors } from '../../utils/color';

const StyledMenuItem = styled(MenuItem)({
  margin: '0',
});

export interface WorkstreamsMenuProps {
  handleClose: () => void;
  changeNavigation: (str: string) => void;
  responsive?: boolean;
}
const WorkstreamsMenu = ({ handleClose, changeNavigation, responsive = false }: WorkstreamsMenuProps) => {
  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Paper sx={{ height: '100%' }}>
        <MenuList id="menu-list-dropdown" style={{ padding: '0' }}>
          {responsive && (
            <StyledMenuItem
              onClick={handleClose}
              sx={{ borderBottom: (theme) => `1px solid ${componentColors(theme.palette.primary).divider}` }}
            >
              <Stack direction="row" alignItems="center">
                <ChevronLeftIcon />
                <Typography variant="subtitle2">Back to Menu</Typography>
              </Stack>
            </StyledMenuItem>
          )}
          <StyledMenuItem
            onClick={() => {
              changeNavigation(`/app/admin/api/tests`);
              handleClose();
            }}
            data-cy="api-opt"
          >
            API
          </StyledMenuItem>
          <StyledMenuItem
            onClick={() => {
              changeNavigation(`/app/admin/adk/suites`);
              handleClose();
            }}
          >
            ADK
          </StyledMenuItem>
          <StyledMenuItem
            onClick={() => {
              changeNavigation(`/app/admin/android-tv`);
              handleClose();
            }}
          >
            Android
          </StyledMenuItem>
        </MenuList>
      </Paper>
    </ClickAwayListener>
  );
};

export default WorkstreamsMenu;
